import React from "react"
import DocumentView from "components/DocumentView"

const sections = [
  {
    name: "Help",
    children: [
      {
        name: "Help & Support",
        subtitle: "Find help about our site, our camps, or more.",
        route: "/help",
        component: require("./pages/help").default,
      },
      {
        name: "Registration Help",
        subtitle: "Help with registration for camps or families.",
        route: "/help/registration",
        component: require("./pages/registration").default,
      },
      {
        name: "Frequently Asked Questions",
        subtitle: "Answers to questions that are frequently asked",
        route: "/help/faq",
        component: require("./pages/faq").default,
      },
      {
        name: "Contact Us",
        subtitle: "Ask questions, voice concerns, find out more.",
        route: "/help/contact",
        component: require("./pages/contact").default,
      },
      {
        name: "Terms and Conditions",
        subtitle: "Terms and conditions of the usage of our site.",
        route: "/help/terms",
        component: require("./pages/terms").default,
      },
    ],
  },
]

const Help = props => <DocumentView sections={sections} />

export default Help



// WEBPACK FOOTER //
// ./src/scenes/Help/index.js